const initialState = { carregado: false, name: null };
export const UsuarioReducer = function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case "MEUS_DADOS":
      return {
        ...state,
        carregado: true,
        ...payload,
      };
    default:
      return state;
  }
};
